/*eslint react/no-string-refs: "off" */

import React from 'react';
import PropTypes from 'prop-types';
import Cropper from 'react-cropper';

import './styles.module.css';
import Button from 'components/Button';
import pica from 'pica';
import { black, exactWhite } from '../../utils/style/colors';
import styled from 'styled-components';

const FilePickerBtn = styled.div`
  background: ${black};
  padding: 0.5rem 0.75rem;
  border-radius: 0.5rem;
  color: var(--exact-white);
`;

class PictureFilePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      src: props.src,
      previousSrc: props.src,
      state: !props.src ? 'non' : 'view',
      edited: false,
    };
    this.finalCanvas = document.createElement('canvas');
    this.finalCanvas.width = this.props.imageMaxDimension.width;
    this.finalCanvas.height = this.props.imageMaxDimension.height;
  }

  openEdit = () => {
    this.setState({
      state: 'edit',
      previousSrc: this.state.src,
    });
  };

  removePicture = () => {
    this.setState({
      state: 'non',
      previousSrc: null,
      src: null,
    });
    this.props.onPictureChange(this.props.item, null);
  };

  onFileChange = (e) => {
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({ src: reader.result, state: 'edit' });
    };
    reader.readAsDataURL(files[0]);
  };

  dataURItoBlob = (dataURI) => {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI.split(',')[1]);

    // separate out the mime component
    const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);

    // create a view into the buffer
    const ia = new Uint8Array(ab);

    // set the bytes of the buffer to the correct values
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    return new Blob([ab], { type: mimeString });
  };
  confirmCrop = () => {
    let croppedCanvas = this.cropper.getCroppedCanvas();
    if (typeof croppedCanvas === 'undefined') {
      return;
    }

    let dataUrl = croppedCanvas.toDataURL();
    this.setState({
      src: dataUrl,
      state: 'view',
    });

    // this.props.onPictureChange(this.props.item, this.dataURItoBlob(dataUrl));
    pica()
      .resize(croppedCanvas, this.finalCanvas, { alpha: true })
      .then((result) => pica().toBlob(result, this.props.outputFormat, 0.7))
      .then((blob) => {
        this.setState({
          src: URL.createObjectURL(blob),
          state: 'view',
        });
        this.props.onPictureChange(this.props.item, blob);
      });
  };

  cancelCrop = () => {
    this.setState({
      src: this.state.previousSrc,
      state: this.state.previousSrc === null ? 'non' : 'view',
    });
  };

  render() {
    const { message } = this.props;
    switch (this.state.state) {
      case 'non':
        return (
          <div className="file-field flex flex-row-reverse">
            <FilePickerBtn>
              <span>{message.chooseFile}</span>
              <input
                type="file"
                ref="filePicker"
                onChange={this.onFileChange}
              />
            </FilePickerBtn>
          </div>
        );
      case 'view':
        return (
          <div className="flex flex-col gap-3">
            <div className="flex" style={{ margin: '1rem auto' }}>
              <img
                className="target"
                alt=""
                src={this.state.src}
                style={this.props.viewStyle}
              />
            </div>
            <div className="flex gap-3 flex-row-reverse mb-4">
              <Button color="black" onClick={this.openEdit}>
                {message.edit}
              </Button>
              <Button color="black" onClick={this.removePicture}>
                {message.delete}
              </Button>
            </div>
          </div>
        );
      case 'edit':
        return (
          <div className="row">
            <div className="row col s12" style={{ marginBottom: '1rem' }}>
              <Cropper
                src={this.state.src}
                aspectRatio={this.props.aspectRatio}
                style={this.props.cropperStyle}
                ref={(element) => (this.cropper = element)}
                autoCropArea={1}
                className="col s12"
              />
            </div>
            <div
              className="col s12"
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
              }}
            >
              <Button color="black" onClick={this.confirmCrop}>
                {message.confirm}
              </Button>
              <div className="file-field left">
                <FilePickerBtn>
                  <span>{message.changeFile}</span>
                  <input
                    type="file"
                    ref="filePicker"
                    onChange={this.onFileChange}
                  />
                </FilePickerBtn>
              </div>
              <Button color="black" onClick={this.cancelCrop}>
                {message.cancel}
              </Button>
            </div>
          </div>
        );
      default:
        return;
    }
  }
}

PictureFilePicker.propTypes = {
  src: PropTypes.string,
  item: PropTypes.object,
  onPictureChange: PropTypes.func.isRequired,
  aspectRatio: PropTypes.number,
  viewStyle: PropTypes.object,
  cropperStyle: PropTypes.object,
  imageMaxDimension: PropTypes.shape({
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  }).isRequired,
  outputFormat: PropTypes.oneOf(['image/jpeg', 'image/png']),
  message: PropTypes.shape({
    confirm: PropTypes.string.isRequired,
    cancel: PropTypes.string.isRequired,
    edit: PropTypes.string.isRequired,
    delete: PropTypes.string.isRequired,
    chooseFile: PropTypes.string.isRequired,
    changeFile: PropTypes.string.isRequired,
  }).isRequired,
};

PictureFilePicker.defaultProps = {
  viewStyle: {
    maxWidth: '100%',
    width: '100%',
  },
  outputFormat: 'image/jpeg',
  cropperStyle: { height: '30em', width: '100%' },
};

export default PictureFilePicker;
